<template>
  <form-field :title="title" is-link :is-require="isRequire" @click="onClick">
    <div v-if="!displaySingle" class="placeholder">请选择{{ title }}</div>
    <div v-else>{{ displaySingle }}</div>
    <van-popup v-model="isShow" get-container="body" position="bottom" close-on-popstate safe-area-inset-bottom @open="onOpen">
      <van-picker v-if="isShow" show-toolbar value-key="name" :title="`选择${title}`" :columns="regionList" :default-index="defaultIndex" @confirm="onConfirmSingle" @cancel="onCancel" />
    </van-popup>
  </form-field>
</template>
<style lang="less" scoped>
.placeholder {
  font-size: 32px;
  color: #bbb;
}
</style>
<script>
import { mapGetters } from 'vuex';
import { isDef } from '@/utils/common';
export default {
  name: 'FormRegion',
  props: {
    value: [Number, String],
    title: String,
    isPublish: {
      type: Boolean,
      default: false,
    },
    isRequire: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      siteId: '',
      display: '',
      isShow: false,
      loading: false,
      columns: [
        // 第一列
        {
          values: [],
          defaultIndex: 0,
        },
        // 第二列
        {
          values: [],
          defaultIndex: 0,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['dict', 'substationOpened']),
    regionList() {
      return this.dict.ODD_SERVICE_REGION_LIST.map(item => {
        return {
          site_id: item.site_id,
          name: item.label,
          id: item.value,
        };
      });
    },
    siteList() {
      return this.dict.SITE_LIST;
    },
    displaySingle() {
      if (isDef(this.value)) {
        const selectItem = this.regionList.find(item => item.id === this.value);
        return selectItem.name;
      } else {
        return ''
      }
    },
    defaultIndex() {
      if (isDef(this.value)) {
        const index = this.regionList.findIndex(item => item.id === this.value);
        return index;
      } else {
        return 0;
      }
    },
  },
  watch: {
    value: {
      handler(val) {
        this.setDefaultPicker();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.setDefaultPicker();
  },
  methods: {
    onClick() {
      this.isShow = true;
    },
    onCancel() {
      this.isShow = false;
    },
    onConfirmSingle(value) {
      this.$emit('input', value.id);
      this.isShow = false;
    },
    onOpen() {
      this.setDefaultPicker();
    },
    async setDefaultPicker() {
      if (!this.substationOpened) {
        return;
      }
      this.loading = true;
      let siteList = this.siteList;
      let regionList = this.regionList;
      let subRegionList = [];
      let siteIndex = 0;
      let regionIndex = 0;
      // if (this.isPublish) {
      //   const allowedPublishSite = await this.$api.getAllowedPublishSiteList();
      //   siteList = allowedPublishSite.SITE_LIST;
      //   const siteIds = siteList.map(item => item.id);
      //   regionList = regionList.filter(item => {
      //     return siteIds.indexOf(item.site_id) > -1;
      //   });
      // }
      const currentRegion = regionList.find(item => item.id === this.value);
      if (currentRegion) {
        this.siteId = currentRegion.site_id;
        subRegionList = regionList.filter(item => item.site_id === currentRegion.site_id);
        siteIndex = siteList.findIndex(item => item.id === currentRegion.site_id);
        regionIndex = subRegionList.findIndex(item => item.id === currentRegion.id);
      } else {
        subRegionList = regionList.filter(item => item.site_id === siteList[0].id);
      }
      this.$set(this.columns[0], 'values', siteList);
      this.$set(this.columns[0], 'defaultIndex', siteIndex > -1 ? siteIndex : 0);
      this.$set(this.columns[1], 'values', subRegionList);
      this.$set(this.columns[1], 'defaultIndex', regionIndex > -1 ? regionIndex : 0);
      this.getDisplay(this.value);
      this.loading = false;
    },
    getDisplay(val) {
      if (!this.substationOpened) {
        return;
      }
      const siteList = this.columns[0].values;
      const subRegionList = this.columns[1].values;
      const region = subRegionList.find(item => item.id === val);
      let site = '';
      if (region) {
        site = siteList.find(item => item.id === region.site_id);
      }
      if (site && region) {
        this.display = site.name + '-' + region.name;
        return;
      }
      this.display = '';
    },
  },
};
</script>
